"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_API_PATH = exports.AdminPath = void 0;
const admin = "/admin";
exports.AdminPath = {
    admin,
};
const api_prefix = "api";
const handlePath = ({ BasePath, path }) => {
    const apiPath = {
        frontend: `${api_prefix}${BasePath}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.ADMIN_API_PATH = {
    //   orderList: handlePath({
    //     BasePath: AdminPath.admin,
    //     path: `new`,
    //   }),
    orderList: (status, fromDate, toDate) => handlePath({
        BasePath: admin,
        path: `orders/${status}/${fromDate}/${toDate}`,
    }),
    pickup: (orderId) => handlePath({
        BasePath: admin,
        path: `pickup/${orderId}`,
    }),
    startShift: (badgeNumber) => handlePath({
        BasePath: admin,
        path: `start_shift/${badgeNumber}`,
    }),
    endShift: (badgeNumber) => handlePath({
        BasePath: admin,
        path: `end_shift/${badgeNumber}`,
    }),
    getShift: (id) => handlePath({
        BasePath: admin,
        path: `shift/${id}`,
    }),
    getOngoingShift: (badgeNumber) => handlePath({
        BasePath: admin,
        path: `ongoing_shift/${badgeNumber}`,
    }),
    getAllShift: () => handlePath({
        BasePath: admin,
        path: `shift`,
    }),
    mySales: () => handlePath({
        BasePath: admin,
        path: `sales/staff`,
    }),
    sales: () => handlePath({
        BasePath: admin,
        path: `sales`,
    }),
    salesByStaff: (staff) => handlePath({
        BasePath: admin,
        path: `sales/${staff}`,
    }),
    //   getOrdersByClient: (clientId: string) =>
    //     handlePath({
    //       BasePath: OrderPath.order,
    //       path: `client/${clientId}`,
    //     }),
    //   confirmPayment: (orderId: string) =>
    //     handlePath({
    //       BasePath: OrderPath.order,
    //       path: `confirm_payment/${orderId}`,
    //     }),
    //   verifyOrderPayment: handlePath({
    //     BasePath: OrderPath.order,
    //     path: `verify`,
    //   }),
};
//# sourceMappingURL=admin.js.map